/*
 * @Author: zxl
 * @Date: 2021-06-08 18:09:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-09 13:58:25
 * @Description: 描述
 * @FilePath: \XBAdmine:\qqjieshou\XBAdminVUE\src\views\Set\Filiale\api\service.js
 */

import axios from '../../../../utils/request';
function GET_DATA(params) {
    return axios.get("/team/ATeamCustomerService/index",{
        params: {
            page:params
        }
    } )
}
function OPEN_ADD(params) {
    return  axios.get("/team/ATeamCustomerService/add",{...params} )
}
function SUBMIT_ADD(params) {
    return  axios.post("/team/ATeamCustomerService/addPost",{...params} )
}
function OPEN_EDIT(params) {
    return  axios.get("/team/ATeamCustomerService/edit",{
        params: {
            id:params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/team/ATeamCustomerService/editPost",{...params} )
}
function CHANG_STATUS_FILALE(params) {
    return  axios.post("/team/ATeamCustomerService/statusEdit",{
        status: {
            ...params
        }
    } )
}
export default {
    GET_DATA,
    OPEN_ADD,
    SUBMIT_ADD,
    OPEN_EDIT,
    SUBMIT_EDIT,
    CHANG_STATUS_FILALE
};
